import { TrackingService } from 'types/analytics';

import ClarityService from './ClarityService';

const createTrackingService = (): TrackingService => {
  return new ClarityService();
};

export default createTrackingService;
